import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';
import Tooltip from '@adsk/bim360-matrix-react-tooltip';

import './SidePanelControl.scss';

class SidePanelControl extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { icon, isActive, disabled } = this.props;
    const iconSize = '30';
    return (
      <div
        className="SidePanel__control-element"
        onClick={() => {
          !disabled && this.props.onClick(icon);
        }}
      >
        <Tooltip content={icon.label} theme={Tooltip.Themes.LIGHT} place={Tooltip.Places.RIGHT}>
          <div
            className={classNames('SidePanel__control-element-icon', {
              'SidePanel__control-element-icon--active': isActive,
              'SidePanel__control-element-icon--disabled': disabled
            })}
          >
            {typeof icon.icon === 'string' ? (
              <SvgIcon svgId={icon.icon} width={iconSize} height={iconSize} />
            ) : (
              icon.icon
            )}
          </div>
        </Tooltip>
      </div>
    );
  }
}

SidePanelControl.propTypes = {
  icon: PropTypes.object.isRequired,
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

SidePanelControl.defaultProps = {
  disabled: false
};

export default SidePanelControl;
